<template>
  <div class="page page-onlinecourses-detail">
    <div class="page-content">
      <div class="breadcrumb-wrapper">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/onlinecourses' }">课程管理</el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: '/onlinecourses/catalogue-editable', query: { id: courseActive.id, status: 'look' } }"
            >课程目录</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ courseActive.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <el-row class="course-info" type="flex">
        <div class="left">
          <img>
        </div>
        <div class="right">
          <h4>小小计算器 - 任务1  体验用计算器计算的操作步骤</h4>
          <p>人们的生活和工作离不开数学计算。20世纪70年代，电子计算器的发明把人类从数学计算的脑力劳动中解放了出来。电子计算器携带方便、价格低廉，现在已成为各行各业必备的办公用品之一。在商业交易中，营业员常用它来计算顾客的消费金额；在教育领域，老师常用它来计算学生的考试成绩；学生们也常用它完成作业题中的计算任务</p>
        </div>
      </el-row> -->
      <el-row class="course-info" type="flex" align="center">
        <!-- <div class="couse_detail_header">
          <div
            class="cover"
            :style="{
              'background-image': `url(${cover})`,
            }"
          >
            <div>{{ courseActive.name }}</div>
          </div>
          <div :style="{ display: 'flex', flexDirection: 'column' }">
            <div class="course-info-item course-info-slogan " :title="courseActive.name || ''">
              {{ $route.query.nodeName || "" }}
            </div>
          </div>
        </div> -->
        <!-- <div v-if="userInfo.type === 'TEACHER' && classroomData.on">
              <p :style="{ color: '#409EFF' }">上课中 {{ timeCount | formatTime }}</p>
            </div> -->

        <!-- <div v-if="userInfo.type === 'STUDENT' && classroomData.on">
              <p :style="{ color: '#409EFF' }">上课中 {{ timeCount | formatTime }}</p>
            </div> -->
        <!-- <div class="course-info-item classes-wrapper" v-if="userInfo.type === 'TEACHER'">
              <div class="classes-list">
                <span
                  v-for="(v, i) in myClassesList.slice(0, 1)"
                  :key="i"
                  :class="['classes-item', { active: v.id === classActive.id }]"
                  @click="classItemClick(v)"
                  >{{ v.name }}</span
                >
              </div>
              <div class="classes-popper-switch" @click.stop="showPopper = !showPopper">
                <i class="switchIcon el-icon-caret-bottom"></i>
                <div :class="['classes-popper', { hide: !showPopper }]" @click.stop>
                  <span
                    v-for="(v, i) in myClassesList"
                    :key="i"
                    :class="['classes-item', { active: v.id === classActive.id }]"
                    @click="classItemClick(v)"
                    >{{ v.name }}</span
                  >
                </div>
              </div>
            </div> -->
        <!-- <template v-if="userInfo.type === 'STUDENT'">
              <div>{{ stuClassInfo.name || "" }}</div>
              <div>班级编号：{{ stuClassInfo.id }}</div>
              <div>学生数量：{{ stuClassInfo.studentNum }}</div>
            </template> -->
        <!-- </div>
        </div> -->
        <!-- <div class="couse_detail_btn">
          <template>
            <p @click="gotoClassroomBegin" v-if="userInfo.type === 'TEACHER' && !classroomData.on">
              开始上课
            </p>
            <template v-if="userInfo.type === 'TEACHER' && classroomData.on">
              <p @click="gotoClassroomEnd">下课</p>
            </template>
          </template>
        </div> -->
      </el-row>
      <el-row class="menu-wrapper" type="flex" align="middle">
        <!-- <el-col :span="18" class="left">
          <el-menu
            ref="menu"
            default-active="baseinfo"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
          >
            <template v-for="(v, i) in menuList">
              <el-submenu v-if="(v.children || []).length" :key="i" :index="String(v.id)">
                <template slot="title">{{ v.nodeName }}</template>
                <el-menu-item v-for="(item, index) in v.children || []" :key="index" :index="String(item.id)">{{
                  item.nodeName
                }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else :key="i" :index="String(v.id)">
                {{ v.nodeName }}
              </el-menu-item>
            </template>
          </el-menu>
        </el-col> -->
      </el-row>
      <tabBaseinfo v-if="menuActiveIndex === 'baseinfo'"></tabBaseinfo>
      <tabWorks v-else-if="menuActiveIndex === 'works'"></tabWorks>
      <evaluateProjectStudent
        v-else-if="menuActiveIndex === 'evaluate-project' && userInfo.type === 'STUDENT'"
      ></evaluateProjectStudent>
      <evaluateProjectTeacher
        v-else-if="menuActiveIndex === 'evaluate-project' && (userInfo.type === 'TEACHER'||userInfo.type === 'TEACHER_RESEARCH')"
      ></evaluateProjectTeacher>
      <evaluateTaskStudent
        v-else-if="menuActiveIndex.startsWith('evaluate-task') && userInfo.type === 'STUDENT'"
        :data="menuActive1"
        :key="menuActiveIndex"
      ></evaluateTaskStudent>
      <evaluateTaskTeacher
        v-else-if="menuActiveIndex.startsWith('evaluate-task') && (userInfo.type === 'TEACHER'||userInfo.type === 'TEACHER_RESEARCH')"
        :data="menuActive1"
        :key="menuActiveIndex"
      ></evaluateTaskTeacher>
      <tabTask v-else :data="menuActive" :key="menuActiveIndex"></tabTask>
    </div>
    <div class="top_fixed" @click="toTopChange">
      <i class="el-icon-top icon"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import tabBaseinfo from "./tab-baseinfo.vue";
import tabTask from "./tab-task.vue";
import tabWorks from "./tab-works.vue";
import evaluateTaskTeacher from "./evaluate-task-teacher.vue";
import evaluateTaskStudent from "./evaluate-task-student.vue";
import evaluateProjectStudent from "./evaluate-project-student.vue";
import evaluateProjectTeacher from "./evaluate-project-teacher.vue";
import publicUrl from "@/assets/js/interface";
import utils from "@/assets/js/utils.js";

export default {
  name: "page-onlinecourses-detail",
  components: {
    tabBaseinfo,
    tabTask,
    tabWorks,
    evaluateTaskTeacher,
    evaluateTaskStudent,
    evaluateProjectStudent,
    evaluateProjectTeacher,
  },
  data() {
    return {
      menuActiveIndex: "",
      showPopper: false,
      projectTasks: [],
      timeCount: 0,
      timer: null,
      flag: false,
      loadingCount: 0,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      classesList: (state) => state.classmanagement.classesList,
      classActiveIndex: (state) => state.classmanagement.classActiveIndex,
      stuClassInfo: (state) => state.classmanagement.stuClassInfo,
      coursesList: (state) => state.onlinecourses.coursesList,
      courseCoverList: (state) => state.courseCoverList,
    }),
    ...mapGetters({
      classActive: "classmanagement/classActive",
      courseActive: "onlinecourses/courseActive",
    }),
    // 计算当前课程封面
    cover() {
      let img;
      if (this.courseActive.cover) {
        img = this.courseActive.cover.includes("cover_")
          ? this.courseCoverList[this.courseActive.cover]
          : this.courseActive.cover;
      } else {
        img = this.courseCoverList["cover_3"];
      }
      return img;
    },

    myClassesList() {
      let result = utils.deepCopy(this.classesList).filter((v) => v.id !== this.classActive.id);
      if (this.classActive && this.classActive.id) {
        result.unshift(utils.deepCopy(this.classActive));
      }
      return result;
    },
    menuList() {
      let evaluateTasks = [];
      if (this.userInfo.type === "TEACHER" || this.userInfo.type === "TEACHER_RESEARCH") {
        this.projectTasks.forEach((v) => {
          evaluateTasks.push({
            id: `evaluate-task-${v.id}`,
            name: "evaluate-task",
            nodeName: `任务评价 ${v.nodeName}`,
          });
        });
      } else {
        evaluateTasks.push({
          id: `evaluate-task`,
          name: "evaluate-task",
          nodeName: `任务评价`,
        });
      }
      return [
        // { id: "baseinfo", name: "baseinfo", nodeName: "基本信息" },
        ...this.projectTasks,
        // { id: "works", name: "works", nodeName: "项目作品" },
        // {id: 'knowlege', name: 'knowlege', nodeName: '知识图谱'},
        // {
        //   id: "evaluate",
        //   name: "evaluate",
        //   nodeName: "评价方案",
        //   children: [{ id: "evaluate-project", name: "evaluate-project", nodeName: "项目评价" }, ...evaluateTasks],
        // },
      ];
    },
    menuDict() {
      let result = {};
      this.menuList.forEach((v) => {
        v && (result[v.id] = v);
      });
      return result;
    },
    menuActive() {
      return this.menuDict[this.menuActiveIndex] || {};
    },
    menuActive1() {
      return this.menuDict[this.menuActiveIndex.substring(14)] || {};
    },
  },
  filters: {
    formatTime(val) {
      return utils.formatTime(val || 0, "mm:ss");
    },
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    this.init();
    document.addEventListener("click", () => {
      this.showPopper = false;
    });
    this.$jstools.myEvent.addEventListener("current-user", () => {
      !this.flag && this.init();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations({
      setClassActiveIndex: "classmanagement/setClassActiveIndex",
      setCourseActiveId: "onlinecourses/setCourseActiveId",
    }),
    ...mapActions({
      getStudentsList: "classmanagement/getStudentsList",
      getGroupsList: "classmanagement/getGroupsList",
      classroomBegin: "onlinecourses/classroomBegin",
      classroomEnd: "onlinecourses/classroomEnd",
      getTextbookInfo: "onlinecourses/getTextbookInfo",
    }),
    toTopChange() {
      document.documentElement.scrollTop = 0;
    },
    init() {
      this.flag = !!this.userInfo.token;
      if (!this.userInfo.token) return;
      // this.getProjectTasks();
      if (this.$route.query.id) {
        this.setCourseActiveId(this.$route.query.id);
        if (this.coursesList.length === 0) {
          this.getTextbookInfo({ vm: this.$root, bookId: this.$route.query.id });
        }
      }
    },

    handleSelect(key) {
      this.menuActiveIndex = key;
    },
    getProjectTasks(menuActiveIndex) {
      this.loadingCount++;
      this.projectTasks = [];
      this.$ajax
        .get(publicUrl.projectTasks, {
          params: {
            projectId: this.$route.query.projectId,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.projectTasks = res.data.data || [];
            menuActiveIndex = menuActiveIndex || String(this.$route.query.taskId) || "baseinfo";
            this.menuActiveIndex = menuActiveIndex;
            this.$nextTick(() => {
              // this.$refs.menu && this.$refs.menu.updateActiveIndex(menuActiveIndex)
              if (this.$refs.menu) {
                this.$refs.menu.activeIndex = menuActiveIndex;
                this.$refs.menu.initOpenedMenu();
              }
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    gotoClassroomBegin() {
      this.classroomBegin({
        vm: this.$root,
        jobId: this.$route.query.taskId,
        projectId: this.$route.query.projectId,
      }).then(() => {});
    },
    gotoClassroomEnd() {
      return this.classroomEnd({ vm: this.$root }).then(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/styles/public.less";

.page-onlinecourses-detail {
  .page-content {
    width: 1200px;
    margin: 0 auto;
    .el-breadcrumb {
      margin-bottom: 20px;
    }
    .course-info {
      .couse_detail_header {
        display: flex;
        .cover {
          width: 276px;
          height: 150px;
          border-radius: 20px;
          background-repeat: no-repeat;
          background-size: cover;
          margin-right: 20px;
          .flex_center;
          > div {
            width: 200px;
            height: 100px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 20px;
            .flex_center;
            text-align: center;
            font-size: 24px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #333333;
            word-wrap: break-word;
          }
        }
      }
      .couse_detail_btn {
        position: absolute;
        right: 10px;
        top: 0;

        > p {
          background: url("../../../assets/images/public/title_icon_bg.png") no-repeat center/contain;
          width: 100px;
          height: 107px;
          font-size: 28px;
          font-family: SourceHanSansCN-Light, SourceHanSansCN;
          font-weight: 300;
          color: #ffffff;
          text-align: center;
          .flex_center;
          padding: 0 20px;
          cursor: pointer;
        }
      }
      .course-info-item {
        display: inline-block;
        position: relative;
        line-height: 40px;
        & + .course-info-item {
          &::before {
            content: "";
            position: absolute;
            left: -10px;
            top: 15px;
            width: 1px;
            height: 10px;
            background-color: #fff;
          }
        }
      }
      .course-info-slogan {
        font-size: 20px;
        font-weight: 600;
        line-height: 40px;
      }
      .classes-wrapper {
        .classes-list {
          position: relative;
        }
        .classes-item {
          display: inline-block;
          width: 100%;
          line-height: 30px;
          padding: 5px 10px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          &.active {
            font-size: 14px;
            font-family: SourceHanSansCN-ExtraLight, SourceHanSansCN;
            font-weight: 200;
            color: #333333;
          }
        }
        .classes-popper-switch {
          position: absolute;
          top: 10px;
          right: 0;
          height: 20px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .classes-popper {
            position: absolute;
            top: 23px;
            right: -11px;
            z-index: 10;
            width: 116px;
            color: #657180;
            background-color: #fff;
            box-shadow: 0 0 10px #dedede;
            text-align: center;
            span:hover {
              background: #e5f6ff;
            }
          }
        }
      }
      .btn-wrapper {
        width: 0;
        flex-grow: 1;
        text-align: right;
      }
    }
    .menu-wrapper {
      padding: 0 15px;
      margin-bottom: 15px;
      background: #f0f2f5;
      .right {
        text-align: right;
      }
    }
  }
}
.top_fixed {
  border-radius: 50%;
  color: #409eff;
  display: flex;
  background: rgba(0, 0, 0, 0.12) 0px 0px 6px;
  box-shadow: 0 0 6px rgba(0,0,0,.12);
  position: fixed;
  right: 200px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  .icon {
    font-size: 30px;
  }
}
</style>
